// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/legacyWorkOrder.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (wo-legacy-orders: imported Open/Closed/Done work orders, read-side.)
//
// Side-effect module: attaches `window.LegacyWorkOrder`. maintenance.js reads it
// at CALL time, never through a cross-`?v=` ES import (Pitfall #1).
//
// The body below is the canonical file's PORTABLE CORE, copied byte for byte.
// =============================================================================
(function () {
  'use strict';

  var LWO_TABS = ['open', 'in_progress', 'pending_review', 'completed'];

  /**
   * The Work Orders tab a status VALUE belongs to: open | in_progress | pending_review | completed.
   * isClosed = the shared vocabulary's isMaintClosed (injected). Without one, only
   * the literal 'completed' is closed — the over-report-open direction.
   */
  function normalizeWorkOrderStatus(status, isClosed) {
    var s = String(status == null ? '' : status).trim().toLowerCase();
    if (typeof isClosed === 'function' ? isClosed(status) : s === 'completed') return 'completed';
    if (LWO_TABS.indexOf(s) >= 0) return s;
    return 'open';
  }

  /** The tab a work order shows in (reads the raw status; see the header). */
  function workOrderTab(t, isClosed) {
    return normalizeWorkOrderStatus(t && t.status, isClosed);
  }

  /** True for the old app's imported shape (kind/text, no current vehicle fields). */
  function isLegacyWorkOrder(t) {
    if (!t || typeof t !== 'object') return false;
    if (t.assetType || t.truckId || t.trailerId) return false;
    return typeof t.text === 'string' || typeof t.kind === 'string';
  }

  function _lwoName(s) {
    return String(s == null ? '' : s).trim().toLowerCase().replace(/^#\s*/, '').replace(/\s+/g, ' ');
  }

  function _lwoGone(v) {
    return !!(v && (v.deletedAt || v.deletedBy || v.status === 'deleted'));
  }

  function _lwoInitials(nick) {
    var words = _lwoName(String(nick == null ? '' : nick).replace(/\([^)]*\)/g, ' ')).split(' ').filter(function (w) { return /^[a-z]/.test(w); });
    if (words.length < 2) return '';
    return words.map(function (w) { return w.charAt(0); }).join('');
  }

  /**
   * The fleet unit a legacy order names, or null. fleets = { trucks, trailers, assets }.
   * Returns { kind: 'truck' | 'trailer' | 'asset', v } — only when exactly one unit matches.
   */
  function resolveLegacyVehicle(t, fleets) {
    var name = _lwoName(t && t.assetName);
    if (!name) return null;
    var f = fleets || {};
    var lists = [['truck', f.trucks], ['trailer', f.trailers], ['asset', f.assets]];
    var exact = [];
    var initials = [];
    for (var i = 0; i < lists.length; i++) {
      var kind = lists[i][0];
      var list = Array.isArray(lists[i][1]) ? lists[i][1] : [];
      for (var j = 0; j < list.length; j++) {
        var v = list[j];
        if (!v || _lwoGone(v)) continue;
        var names = [v.unit, v.nickname, v.name].map(_lwoName).filter(Boolean);
        if (names.indexOf(name) >= 0) exact.push({ kind: kind, v: v });
        else if (kind !== 'asset' && /^[a-z]{2,4}$/.test(name) && _lwoInitials(v.nickname) === name) initials.push({ kind: kind, v: v });
      }
    }
    if (exact.length === 1) return exact[0];
    if (exact.length > 1) return null; // two units share the name: never guess
    return initials.length === 1 ? initials[0] : null;
  }

  /**
   * A work order as the current app reads it. A current-shape order comes back as
   * the SAME object, untouched. An imported order (it carries the old `text` /
   * `kind` fields) comes back as a COPY with the old fields read into the current
   * ones, `legacy: true` and the raw status in `legacyStatus`. Its vehicle is
   * resolved by name ONLY while it has none of its own — once someone edits it in
   * the app and picks a vehicle (saveTask writes assetType + the id), that choice
   * stands and the old text fields still read. Pass fleets = null until every
   * fleet list has loaded: a name that is unique in a half-loaded fleet must not
   * attach. isClosed = the shared vocabulary (injected).
   */
  function normalizeWorkOrder(t, fleets, isClosed) {
    if (!t || typeof t !== 'object') return t;
    if (typeof t.text !== 'string' && typeof t.kind !== 'string') return t;
    var status = normalizeWorkOrderStatus(t.status, isClosed);
    var o = {};
    for (var k in t) if (Object.prototype.hasOwnProperty.call(t, k)) o[k] = t[k];
    o.legacy = true;
    o.legacyStatus = t.status;
    if (t.priority !== 'critical') o.status = status;
    if (o.description == null && typeof t.text === 'string') o.description = t.text;
    if (o.category == null && typeof t.kind === 'string' && t.kind.trim()) o.category = t.kind.trim();
    if (o.createdBy == null && typeof t.by === 'string' && t.by.trim()) o.createdBy = t.by.trim();
    if (status === 'completed') {
      if (o.completedAt == null && t.signedOffAt) o.completedAt = t.signedOffAt;
      if (o.completedBy == null && typeof t.signedOffBy === 'string' && t.signedOffBy.trim()) o.completedBy = t.signedOffBy.trim();
    }
    if (!isLegacyWorkOrder(t)) return o; // edited in the app: its saved vehicle stands
    var typed = typeof t.assetName === 'string' ? t.assetName.trim() : '';
    o.legacyAssetId = t.assetId;
    o.legacyAssetName = typed;
    var hit = fleets ? resolveLegacyVehicle(t, fleets) : null;
    delete o.assetId;
    delete o.assetName;
    if (hit && hit.kind === 'trailer') {
      o.assetType = 'trailer';
      o.trailerId = hit.v.id;
      o.trailerUnit = String(hit.v.unit || hit.v.nickname || typed);
    } else if (hit && hit.kind === 'asset') {
      o.assetType = 'asset';
      o.assetId = hit.v.id;
      o.assetName = String(hit.v.name || typed);
    } else if (hit) {
      o.assetType = 'truck';
      o.truckId = hit.v.id;
      o.truckUnit = String(hit.v.unit || hit.v.nickname || typed);
    } else {
      // Not in the fleet (or ambiguous): keep the typed name, no id.
      o.assetType = 'truck';
      o.truckUnit = typed;
    }
    return o;
  }

  window.LegacyWorkOrder = Object.freeze({
    normalizeWorkOrderStatus: normalizeWorkOrderStatus,
    workOrderTab: workOrderTab,
    isLegacyWorkOrder: isLegacyWorkOrder,
    resolveLegacyVehicle: resolveLegacyVehicle,
    normalizeWorkOrder: normalizeWorkOrder
  });
})();
